import { useEffect, useMemo, useState } from 'react';
import { useShouldShowCustomViewer } from 'hooks/IAFeaturesHook';

const FileViewerLogic = ({ activeStep, handleMarkAsRead }) => {
  // File properties
  const isFFEnabled = useShouldShowCustomViewer();
  const { content: link, content_size, name: title, uuid } = activeStep;

  // Preview only works for file sizes < 25mb
  const isDisabled = useMemo(() => Math.trunc(content_size / (1024 * 1024)) >= 25, [content_size]);

  const isImage = useMemo(() => {
    if (!link) return false;
    return link.match(/^http[^\?]*.(jpg|jpeg|png|svg)(\?(.*))?$/gim);
  }, [link]);

  const isFile = useMemo(() => {
    if (!link) return false;
    return ['.xlsx', '.docx', '.pptx', '.pdf', '.csv', '.txt'].some((ext) => link.endsWith(ext));
  }, [link]);

  const isExcel = useMemo(() => {
    if (!link) return false;
    return ['.xlsx'].some((ext) => link.endsWith(ext));
  }, [link]);

  const isWord = useMemo(() => {
    if (!link) return false;
    return ['.docx'].some((ext) => link.endsWith(ext));
  }, [link]);

  const isPdf = useMemo(() => {
    if (!link) return false;
    return ['.pdf'].some((ext) => link.endsWith(ext));
  }, [link]);

  const isSimpleFile = useMemo(() => {
    if (!link) return false;
    return ['.txt'].some((ext) => link.endsWith(ext));
  }, [link]);

  const isPresentation = useMemo(() => {
    if (!link) return false;
    return ['.pptx'].some((ext) => link.endsWith(ext));
  }, [link]);

  const includedFiles = useMemo(() => {
    if (!link) return false;
    return ['.xlsx', '.docx', '.pptx', '.pdf', '.txt'].some((ext) => link.endsWith(ext));
  }, [link]);

  // Loading handlers
  const [loading, setLoading] = useState(true);
  const [documentLoaded, setDocumentLoaded] = useState(false);

  useEffect(() => {
    return function resetLoaded() {
      setDocumentLoaded(false);
      setLoading(true);
    };
  }, [uuid]);

  //File preview has loaded successfully
  const onFilePreviewLoad = (e) => {
    setLoading(false);
    setDocumentLoaded(true);
    handleMarkAsReadTrigger();
  };

  const handleMarkAsReadTrigger = (e) => {
    !activeStep.content_read ? handleMarkAsRead(activeStep) : e?.preventDefault();
  };

  return {
    isImage,
    isFile,
    isDisabled,
    loading,
    title,
    link,
    documentLoaded,
    isExcel,
    onFilePreviewLoad,
    isWord,
    isPdf,
    isFFEnabled,
    isSimpleFile,
    isPresentation,
    includedFiles,
  };
};

export default FileViewerLogic;
